import { escalationStageError } from "./escalation-settings";
import { Button } from "./ui/button";
import { Select } from "./ui/select";
import { Switch } from "./ui/switch";
export function OutcomeSettings({
  enabled,
  target,
  working,
  stages,
  onEnabled,
  onTarget,
  criteriaStatus = "PENDING",
  disabled = false,
  loading = false,
  error = false,
  onRetry,
}: {
  enabled: boolean;
  target: string | null;
  working: readonly string[];
  stages: readonly { id: string; name: string }[];
  onEnabled: (value: boolean) => void;
  onTarget: (value: string | null) => void;
  criteriaStatus?: "PENDING" | "READY" | "UNDEFINED";
  disabled?: boolean;
  loading?: boolean;
  error?: boolean;
  onRetry?: () => void;
}) {
  const stageError = escalationStageError(enabled, target, working);
  return (
    <fieldset className="space-y-3 rounded-lg border bg-card p-4" disabled={disabled}>
      <legend className="text-sm font-medium">Результат работы агента</legend>
      <p className="text-sm text-muted-foreground">
        {criteriaStatus === "PENDING"
          ? "Критерии появятся после нового сообщения."
          : criteriaStatus === "READY"
            ? "Критерии определены по обязательным вопросам промпта."
            : "Обязательные вопросы в промпте не определены."}
      </p>
      <label className="flex items-center justify-between gap-4 text-sm font-medium">
        <span>Передавать при достижении цели</span>
        <Switch
          aria-label="Передавать при достижении цели"
          checked={enabled}
          onCheckedChange={onEnabled}
        />
      </label>
      {enabled && (
        <>
          {loading ? (
            <div role="status" className="h-10 animate-pulse rounded bg-muted">
              Загрузка этапов…
            </div>
          ) : error ? (
            <div role="alert">
              Не удалось загрузить этапы amoCRM.{" "}
              <Button variant="outline" size="sm" type="button" onClick={onRetry}>
                Повторить
              </Button>
            </div>
          ) : (
            <label className="block text-sm">
              Этап при достижении цели
              <Select
                className="mt-2"
                value={target ?? ""}
                onChange={(e) => onTarget(e.target.value || null)}
              >
                <option value="">Выберите этап</option>
                {stages.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </Select>
            </label>
          )}
          {stageError && (
            <p role="alert" className="text-sm text-destructive">
              {stageError}
            </p>
          )}
        </>
      )}
    </fieldset>
  );
}
